import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { AttachmentSection } from "@domain/lms/article/article";
import { DetailedArticle } from "@domain/lms/article/dtos";
import { getAssetById } from "@domain/lms/article/utils";
import { Secondary } from "@ui/components/containers/textBlocks";
import { FileIcon } from "@ui/components/icons";
import { gap } from "@ui/styles/utils";

interface AttachmentSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: AttachmentSection;
	article: DetailedArticle;
}
export const AttachmentSectionView: React.FC<AttachmentSectionViewProps> = ({ section, article, ...htmlProps }) => {
	const asset = getAssetById(article.content, section.assetId);

	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			{/*<Primary>{I18n.t("article.section.attachment.title", { type: asset.mimeType.split("/")[1] })}</Primary>*/}
			<Secondary>
				<a href={asset.url} target="_blank" rel="noreferrer">
					<FileIcon />
					{section.title || I18n.t("article.section.attachment.download")}
				</a>
			</Secondary>
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
	padding-left: 40px;
	@media (max-width: 900px) {
		padding-left: 20px;
	}
	${({ theme }) => theme.textStyles.primary};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	a {
		display: flex;
		align-items: center;
		svg {
			margin-right: 10px;
		}
	}
`;
